export enum DocumentTypeAvailabilityEnum {
  Unavailable = 0,
  Available = 1,
  Mandatory = 2,
}
